/**
 * 航班相关常量定义
 * 统一管理航班性质、航段类型等枚举值，避免重复定义
 */

// 航班性质 (STC Type - Schedule Type Code)
export const STC_TYPE_OPTIONS = [
    { label: "LIVE", value: "LIVE" },
    { label: "TECHSTOP", value: "TECHSTOP" },
    { label: "FERRY", value: "FERRY" },
    { label: "TRAINING", value: "TRAINING" },
    { label: "MAINTENANCE", value: "MAINTENANCE" },
    { label: "TEST", value: "TEST" },
    { label: "CANCEL", value: "CANCEL" },
];

// 航班性质映射 (用于显示)
export const STC_TYPE_LABELS = {
    LIVE: "LIVE",
    TECHSTOP: "TECHSTOP", 
    FERRY: "FERRY",
    TRAINING: "TRAINING",
    MAINTENANCE: "MAINTENANCE",
    TEST: "TEST",
    CANCEL: "CANCEL",
};

// 航班性质颜色映射 (用于Tag组件)
export const STC_TYPE_COLORS = {
    LIVE: "green",
    TECHSTOP: "orange",
    FERRY: "purple",
    TRAINING: "blue",
    MAINTENANCE: "red",
    TEST: "cyan",
    CANCEL: "default",
};

// 航段类型 (Leg Type)
export const LEG_TYPE_OPTIONS = [
    { label: "DOMESTIC", value: "DOMESTIC" },
    { label: "INTERNATIONAL", value: "INTERNATIONAL" },
    { label: "REGIONAL", value: "REGIONAL" },
];

// 航段类型映射
export const LEG_TYPE_LABELS = {
    DOMESTIC: "DOMESTIC",
    INTERNATIONAL: "INTERNATIONAL", 
    REGIONAL: "REGIONAL",
};

// 航段类型颜色映射
export const LEG_TYPE_COLORS = {
    DOMESTIC: "green",
    INTERNATIONAL: "blue",
    REGIONAL: "orange",
};

// 默认值
export const DEFAULT_STC_TYPE = "LIVE";
export const DEFAULT_LEG_TYPE = "DOMESTIC";

// 工具函数：获取航班性质标签
export const getStcTypeLabel = (stcType) => {
    return STC_TYPE_LABELS[stcType] || stcType || "";
};

// 工具函数：获取航班性质颜色
export const getStcTypeColor = (stcType) => {
    return STC_TYPE_COLORS[stcType] || "default";
};

// 工具函数：获取航段类型标签
export const getLegTypeLabel = (legType) => {
    return LEG_TYPE_LABELS[legType] || legType || "UNKNOWN";
};

// 工具函数：获取航段类型颜色
export const getLegTypeColor = (legType) => {
    return LEG_TYPE_COLORS[legType] || "default";
};
